import * as React from 'react';
import { Layout } from './Layout';

export const LayoutContainer: React.FC = () => {
	return <Layout />;
};
